"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luminanceJs = require("luminance-js");

var _moment = _interopRequireWildcard(require("moment"));

require("moment/locale/de");

require("moment/locale/it");

require("moment/locale/en-gb");

require("moment/locale/es");

require("moment/locale/fr");

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _Week = _interopRequireDefault(require("./Week"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  calendar: function calendar(props) {
    return _objectSpread({
      position: 'absolute',
      display: props.display ? 'flex' : 'none',
      flexDirection: 'column',
      background: 'white',
      width: '300px',
      fontFamily: "'Open Sans', sans-serif",
      textAlign: 'center',
      zIndex: 9999,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      marginTop: 5
    }, props.style.calendar);
  },
  '@media screen and (max-width: 600px)': {
    calendar: {
      width: 'auto !important'
    }
  },
  monthDisplay: function monthDisplay(props) {
    return _objectSpread({
      backgroundColor: props.style.secondary ? props.style.secondary : '#fff',
      color: (0, _luminanceJs.luminance)(props.style.secondary ? props.style.secondary : '#fff') > 0.5 ? '#333' : '#fff',
      textTransform: 'capitalize',
      alignItems: 'center',
      padding: 10,
      display: 'flex',
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
      borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
    }, props.style.monthDisplay);
  },
  monthSelected: function monthSelected(props) {
    return _objectSpread({
      flex: 1,
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10
    }, props.style.monthSelected);
  },
  previous: function previous(props) {
    return _objectSpread({
      height: 18,
      width: 18,
      marginLeft: 10,
      cursor: 'pointer',
      transform: 'rotate(180deg)'
    }, props.style.previous);
  },
  next: function next(props) {
    return _objectSpread({
      height: 18,
      width: 18,
      marginRight: 10,
      cursor: 'pointer'
    }, props.style.next);
  },
  weekDays: function weekDays(props) {
    return _objectSpread({
      display: 'flex',
      background: '#fafafa'
    }, props.style.weekDays);
  },
  weekDay: function weekDay(props) {
    return _objectSpread({
      fontWeight: 600,
      padding: 3,
      textAlign: 'center',
      textTransform: 'uppercase',
      width: '100%'
    }, props.style.weekDay);
  },
  todayButton: function todayButton(props) {
    return _objectSpread({
      backgroundColor: props.style.secondary ? props.style.secondary : '#fafafa',
      color: (0, _luminanceJs.luminance)(props.style.secondary ? props.style.secondary : '#fafafa') > 0.5 ? '#333' : '#fff',
      cursor: 'pointer',
      padding: 10,
      fontSize: '0.9em',
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
      borderTop: '1px solid rgba(0, 0, 0, 0.08)'
    }, props.style.todayButton);
  }
};

var Calendar =
/*#__PURE__*/
function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      days: null,
      month: null,
      selected: null
    });

    _defineProperty(_assertThisInitialized(_this), "changeMonth", function () {
      var sens = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'next';
      var month = _this.state.month;

      _this.setState({
        month: sens === 'next' ? month.add(1, 'month') : month.subtract(1, 'month')
      });
    });

    _defineProperty(_assertThisInitialized(_this), "canSelectDate", function (day) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate;
      var canSelectDate = true;

      if (minDate !== undefined && maxDate !== undefined) {
        var startDate = (0, _moment.default)(minDate);
        var endDate = (0, _moment.default)(maxDate);
        if (day.date >= startDate && day.date <= endDate) canSelectDate = true;else canSelectDate = false;
      } else if (minDate !== undefined && maxDate === undefined) {
        var _startDate = (0, _moment.default)(minDate);

        if (day.date >= _startDate) canSelectDate = true;else canSelectDate = false;
      } else if (minDate === undefined && maxDate !== undefined) {
        var _endDate = (0, _moment.default)(maxDate);

        if (day.date <= _endDate) canSelectDate = true;else canSelectDate = false;
      }

      return canSelectDate;
    });

    _defineProperty(_assertThisInitialized(_this), "selectDay", function (day) {
      var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var changeInputDate = _this.props.changeInputDate;

      if (_this.canSelectDate(day)) {
        if (today) {
          // We set time at 00:00:00 for compare with others days
          day.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
          });

          _this.setState({
            selected: day,
            month: day.clone()
          }, function () {
            return changeInputDate(day);
          });
        } else {
          _this.setState({
            selected: day.date,
            month: day.date.clone()
          }, function () {
            return changeInputDate(day.date);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderMonthLabel", function () {
      var classes = _this.props.classes;
      var month = _this.state.month;
      var monthToDisplay = month.format('MMMM YYYY');
      return _react.default.createElement("span", {
        className: classes.monthSelected
      }, monthToDisplay);
    });

    _defineProperty(_assertThisInitialized(_this), "renderWeeks", function () {
      var _this$props2 = _this.props,
          style = _this$props2.style,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate;
      var weeks = [];
      var done = false;

      var date = _this.state.month.clone().startOf('month').add('w' - 1).day((0, _moment.default)().startOf('week').format('dddd'));

      var count = 0;
      var monthIndex = date.month();

      while (!done) {
        weeks.push(_react.default.createElement(_Week.default, {
          key: date,
          date: date.clone(),
          selectDay: function selectDay(day) {
            return _this.selectDay(day);
          },
          selectedMonth: _this.state.month,
          selected: _this.state.selected,
          style: style,
          minDate: minDate,
          maxDate: maxDate
        }));
        date.add(1, 'w');
        done = count++ > 2 && monthIndex !== date.month();
        monthIndex = date.month();
      }

      return weeks;
    });

    return _this;
  }

  _createClass(Calendar, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this$props3 = this.props,
          dateSelected = _this$props3.dateSelected,
          lang = _this$props3.lang,
          minDate = _this$props3.minDate;

      _moment.default.locale(lang);

      var days = [];
      var daysToMove = [];
      var findFirstDay = false; // Order days in week

      _moment.default.weekdays().map(function (day, index) {
        if ((index === 0 || day !== (0, _moment.default)().startOf('week').format('dddd')) && !findFirstDay) {
          daysToMove.push(day);
        } else {
          findFirstDay = true;
          days.push(day);
        }

        return day;
      });

      var month = (0, _moment.default)();

      if (minDate !== undefined) {
        var md = (0, _moment.default)(minDate);

        if ((0, _moment.default)() < md) {
          month = md;
        }
      }

      this.setState({
        days: days.concat(daysToMove),
        month: month,
        selected: dateSelected ? dateSelected : month.startOf('day')
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          arrow = _this$props4.arrow,
          classes = _this$props4.classes,
          todayTxt = _this$props4.todayTxt;
      return _react.default.createElement("section", {
        className: classes.calendar
      }, _react.default.createElement("header", {
        className: classes.header
      }, _react.default.createElement("div", {
        className: classes.monthDisplay
      }, _react.default.createElement("img", {
        className: classes.previous,
        src: arrow,
        onClick: function onClick() {
          return _this2.changeMonth('previous');
        },
        alt: "previous"
      }), this.renderMonthLabel(), _react.default.createElement("img", {
        className: classes.next,
        src: arrow,
        onClick: function onClick() {
          return _this2.changeMonth();
        },
        alt: "next"
      })), _react.default.createElement("div", {
        className: classes.weekDays
      }, this.state.days.map(function (day) {
        return _react.default.createElement("span", {
          key: day,
          className: classes.weekDay
        }, day.charAt(0));
      }))), this.renderWeeks(), this.canSelectDate((0, _moment.default)()) && _react.default.createElement("footer", {
        className: classes.todayButton,
        onClick: function onClick() {
          return _this2.selectDay((0, _moment.default)(), true);
        }
      }, todayTxt));
    }
  }]);

  return Calendar;
}(_react.Component);

var _default = (0, _reactJss.default)(styles)(Calendar);

exports.default = _default;